let routes = [
  // 首页
  {
    path: '/',
    redirect: '/login',
    component: () => import('@/views/insurance/Login.vue'),
    meta: {
      keepAlive: false,
      title: '人寿保险，守护农产品成长'
    },
    children: [
      // 登录
      {
        path: 'login',
        name: 'login',
        component: () => import('@/views/insurance/Login.vue'),
        meta: {
          keepAlive: false,
          title: '人寿保险，守护农产品成长'
        }
      }
    ]
  },
  //
  {
    path: '/insurance',
    name: 'insurance',
    component: () => import('@/views/insurance/Insurance.vue'),
    meta: {
      keepAlive: false,
      title: '人寿保险，守护农产品成长'
    }
  },
  // 表单
  {
    path: '/form',
    name: 'form',
    component: () => import('@/views/insurance/Form.vue'),
    meta: {
      keepAlive: true,
      title: '确认信息'
    }
  },
  // 服务协议
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import('@/views/insurance/Agreement.vue'),
    meta: {
      keepAlive: false,
      title: '确认信息'
    }
  },
  // 签字
  {
    path: '/signature',
    name: 'signature',
    component: () => import('@/views/insurance/Signature.vue'),
    meta: {
      keepAlive: false,
      title: '确认信息'
    }
  },
  // 完成
  {
    path: '/finished',
    name: 'finished',
    component: () => import('@/views/insurance/Finished.vue'),
    meta: {
      keepAlive: false,
      title: '完成'
    }
  },
  // 人脸识别
  {
    path: '/recognition',
    name: 'recognition',
    component: () => import('@/views/insurance/Face.vue'),
    meta: {
      keepAlive: false,
      title: '人脸采集'
    }
  },
  {
    path: '/article1',
    name: 'article1',
    component: () => import('@/views/insurance/Article1.vue'),
    meta: {
      keepAlive: false,
      title: '低温指数保险条款'
    }
  },
  {
    path: '/article2',
    name: 'article2',
    component: () => import('@/views/insurance/Article2.vue'),
    meta: {
      keepAlive: false,
      title: '热带气旋风力指数保险条款'
    }
  },
  // 团队模块
  {
    path: '/team',
    redirect: '/team/team-login',
    component: () => import('@/views/insurance/team/Index.vue'),
    children: [
      {
        path: 'team-login',
        name: 'teamLogin',
        component: () => import('@/views/insurance/team/TeamLogin.vue'),
        meta: {
          keepAlive: false,
          title: '用户登录'
        }
      },
      {
        path: 'form',
        name: 'form',
        component: () => import('@/views/insurance/team/Form.vue'),
        meta: {
          keepAlive: false,
          title: '确认信息'
        }
      },
      {
        path: 'finished',
        name: 'finished',
        component: () => import('@/views/insurance/team/Finished.vue'),
        meta: {
          keepAlive: false,
          title: '确认信息'
        }
      }
    ]
  },
  // 公告栏
  {
    path: '/batch',
    name: 'batch',
    component: () => import('@/views/insurance/batch/Batch.vue'),
    meta: {
      keepAlive: false,
      title: '公告栏'
    }
  },
  {
    path: '/batch/detail',
    name: 'batchDetail',
    component: () => import('@/views/insurance/batch/Detail.vue'),
    meta: {
      keepAlive: false,
      title: '批次详情'
    }
  }
]

routes = [...routes]

export default routes
